import React, { SyntheticEvent, useCallback, useEffect, useRef, useState } from "react";
import {
  Button,
  Container,
  Icon,
  List,
  ListItem,
  Modal,
  ModalActions,
  ModalContent,
  ModalHeader,
  Step,
} from "semantic-ui-react";
import styles from "./SelectBoxSize.module.css";

interface ISelectBoxSizeProps {
    selectedBoxSize: string;
    setSelectedBoxSize: (boxSize: string) => void;
}

function SelectBoxSize(props: Readonly<ISelectBoxSizeProps>) {
    const onBoxSizeSelected = (event: SyntheticEvent) => {
        let selectedBoxSizeElemementId: string | undefined = event.currentTarget.id;

        selectBoxSize(selectedBoxSizeElemementId);
    }

    const selectBoxSize = (boxSize: string) => {
        let container = document.querySelector(".box-size-selection-container");

        container?.querySelectorAll("input").forEach(input => {
            input.checked = false;
        });

        let selectedElement: HTMLInputElement | undefined | null = container?.querySelector(`#${boxSize}`);

        if(selectedElement === undefined || selectedElement === null) return;

        selectedElement.checked = true;

        props.setSelectedBoxSize(boxSize);
    }

    useEffect(() => {
        if(props.selectedBoxSize === "") return;

        selectBoxSize(props.selectedBoxSize);
    }, [])

    return (
        <div className="box-size-selection-container">
            <List>
                <ListItem>
                    <label className={styles["box-size-selection-label"]}>S
                        <input onClick={onBoxSizeSelected} id="S" type="checkbox"></input>
                    </label>
                </ListItem>
                <ListItem>
                    <label className={styles["box-size-selection-label"]}>M
                        <input onClick={onBoxSizeSelected} id="M" type="checkbox"></input>
                    </label>
                </ListItem>
                <ListItem>
                    <label className={styles["box-size-selection-label"]}>L
                        <input onClick={onBoxSizeSelected} id="L" type="checkbox"></input>
                    </label>
                </ListItem>
                <ListItem>
                    <label className={styles["box-size-selection-label"]}>XL
                        <input onClick={onBoxSizeSelected} id="XL" type="checkbox"></input>
                    </label>
                </ListItem>
            </List>
        </div>
    )
}


export default SelectBoxSize;